import _ from 'lodash';

export const fieldQuery = (root_code, mode, form_id, fieldId, form_state, params, search = '', record_id = '', onDone = (result) => {} ) => {
    if(_.isObject(fieldId as any))fieldId = fieldId.id
    return fetch(`${process.env.REACT_APP_FORMS_API}/forms/field-query/${root_code}/${fieldId}/${mode}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify({
            mode,form_state,params,search,record_id,form_id
        } )
    }).then( res => res.json() ).then( content => {
        if(onDone)onDone(content)
        return content
    })
}